import { createGlobalStyle } from 'styled-components';

import ResetCSS from './resetCSS';

const BasicCSS = createGlobalStyle`
  ${ResetCSS}
  html {
    box-sizing: border-box;
    width: 100%;
    min-height: 100%;
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }

  body {
    width: 100%;
    min-height: 100vh;
    font-weight: normal;
    font-family: ${(props) => props.theme.font.regular};
    color: ${(props) => props.theme.color.basicFontColor};
    font-size: ${(props) => props.theme.copytext.copyStandard.fontSize};
    line-height: ${(props) => props.theme.copytext.copyStandard.lineHeight};
    -webkit-font-smoothing: antialiased;
    word-break: break-word;
  }

  #onetrust-pc-sdk.ot-hide {
    display: none !important;
  }

  button {
    background: none;
    border: none;
    color: inherit;
    font-size: inherit;
    font-family: inherit;
    padding: 0;
    display: inline-block;
    cursor: pointer;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  select,
  option {
    appearance: none;
    border: none;
    border-radius: 0;
  }

  select::-ms-expand {
    display: none;
  }

  ::selection {
    background: ${(props) => props.theme.color.primary800};
    color: ${(props) => props.theme.color.white500};
  }

  ::-moz-selection {
    background: ${(props) => props.theme.color.primary800};
    color: ${(props) => props.theme.color.white500};
  }

  input[type='search'],
  input[type='text'] {
    -webkit-appearance: none;
    border-radius: 0;
  }
  
  b, strong {
    font-family: ${(props) => props.theme.font.bold};
    font-weight: 700;
  }
`;

export default BasicCSS;
